import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom'

import { useHistoryWithReferrer } from '@utils/history';
import { IBoxBlueprint, IProduct } from "@interfaces/_cart";

import { addActiveBoxLines, addNewBox, emptyCart, setActiveBoxBlueprint, recalculateActiveBoxTotals, updateCartProducts, addChildBox } from '@app/store/rtk.cart.store';
import { store } from '@v2/store';

import ShopBody from '@components/pages/shop/partial/body';

import v2WrapperStyles from '@styles/wrapper';
import styles from '@v2/components/pages/shop/shop.styles';
import ProductService from '@v2/services/product.service';
//import { usePDPModal } from '@v2/components/common/presentational/modal/common';
import { useGTMItemDispatch } from '@v2/utils/gtm';
import { setEntities } from '@app/store/rtk.entities.store';
import { useEntity } from '@app/store/rtk.entities.selectors';
import { useUser } from '@v2/store/rtk.user.selectors';
import { useUpdateActiveChild } from '../quiz/utils';
import dayjs from 'dayjs';
import cloneDeep from 'lodash.clonedeep';

// No idea how to name this
function LabelsCarousel() {
    const items = [
        'USDA Organic',
        'Clean Label Certified',
        'Non-GMO',
        'BPA-Free',
        'Made with Gluten-Free Ingredients',
        'Farm Fresh',
        'Veggie-First',
    ];

    const rotate = items.concat(items);

    return (
        <div className="shop-carousel">
            <ul className="items">
                {rotate.map((item: any, key: any) =>
                    <React.Fragment key={key}>
                        <li>{item}</li>
                        <li><span className="shop-carousel-point"></span></li>
                    </React.Fragment>
                )}
            </ul>
            <ul className="items copy">
                {rotate.map((item: any, key: any) =>
                    <React.Fragment key={key}>
                        <li>{item}</li>
                        <li><span className="shop-carousel-point"></span></li>
                    </React.Fragment>
                )}
            </ul>
        </div>
    );
}

function ShopPageBody() {
    const dispatch = useDispatch();
    const gtmDispatch = useGTMItemDispatch();
    const location = useLocation();
    const history = useHistoryWithReferrer();
    const [loading, setLoading] = useState(true);
    const blueprints = useEntity('blueprints');
    const bundles = useEntity('bundles');
    const user = useUser();
    const updateActiveChild = useUpdateActiveChild();

    // Load survey result by url
    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get('childName') && params.get('childBirthdate')) {
            const parent = {
                firstName: user?.firstName ? user.firstName : (params.get('firstName') || ''),
                email: user?.email ? user.email : (params.get('email') || ''),
                isLoggedIn: user?.email ? true : false,
            }

            const child = {
                name: params.get('childName'),
                gender: ['unspecified', 'male', 'feamale'].includes(params.get('childGender'))
                            ? params.get('childGender')
                            : 'unspecified',
                birthdate: dayjs(params.get('childBirthdate')).format('YYYY-MM-DD'),
                packItems: [14, 28, 42, 56].includes(parseInt(params.get('packItems')))
                            ? parseInt(params.get('packItems'))
                            : null,
                isVegan: params.get('isVegan') ? true : false,
                recommendedPacksEnabled: true,
                milestoneIds: params.get('milestoneIds') ? params.get('milestoneIds').split(',') : [],
            }

            dispatch(emptyCart());
            dispatch(addChildBox({ parent, child }));

            const cart = store.getState()["cart"] ? store.getState()["cart"] : {};
            const box = cart?.data?.cart?.boxes[cart?.data?.activeChildBox] || {};
            const newBox = cloneDeep(box);

            ProductService.recommended(box.child).then((stage) => {
                if (!stage) {
                    console.error('No stage was found for survey user: ' + params.get('email'));
                    dispatch(emptyCart());
                    return;
                }

                newBox.incomplete = false;
                newBox.survey.completed = true;
                newBox.survey.previousScreen = 'none';
                newBox.survey.activeScreen = 'overview';

                updateActiveChild(null, newBox, stage);
                dispatch(recalculateActiveBoxTotals());
            }).catch((err) => {
                console.error('Error generating personalized bundle by url: ' + parent?.email);
            });
        }
    }, []);

    useEffect(() => {
        ProductService.list()
            .then(data => {
                dispatch(setEntities(data));
                dispatch(updateCartProducts({ data }));
                setLoading(false);

                const blacklist = [
                    'bars',
                    'bonebrothpouches',
                    'boxes',
                    'categories',
                    'pouches',
                    'smoothies'
                ];

                const products: IProduct[] = [];
                Object.keys(data).forEach((key: string) => {
                    if (!blacklist.includes(key)) {
                        ((data as any) as { [key: string]: IProduct[] })[key].forEach((product: IProduct) => products.push(product));
                    }
                });

                gtmDispatch('view_item_list', products);
            })
            .catch(console.error);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get('cart') && blueprints && bundles) {
            const bundleId = params.get('cart');
            const bundle = Object.values(bundles).find((bundle: IProduct) => bundle.slug === bundleId) as IProduct;

            if (bundle) {
                const size = (bundle as IProduct).size;
                const blueprint = Object.values(blueprints).find((box: IBoxBlueprint) => box.minItems <= size && box.maxItems >= size);

                if (blueprint) {
                    dispatch(emptyCart());
                    dispatch(addNewBox({}));
                    dispatch(setActiveBoxBlueprint( { box: { blueprint: blueprint as IBoxBlueprint, boxType: 'custom', title: bundle.title, image: bundle.mainImage }}));
                    dispatch(addActiveBoxLines({ bundle }));
                    dispatch(recalculateActiveBoxTotals());

                    history.pushWithReferrer('/checkout');
                }
            }
        }
    }, [blueprints]);

    return (
        <div className={[v2WrapperStyles.v2Global, styles.pageContainer].join(' ')}>
            <div className="page-heading">
                <h1>Shop</h1>
                <p>Smart food for a developing brain and body ™</p>
                <div className="slider"></div>
            </div>
            <LabelsCarousel />
            <ShopBody loading={loading} />
        </div>
    );
}

const ShopPage = React.memo(ShopPageBody, function (prev, next) {
    return true;
});

export default ShopPage;